import React, {Fragment, PureComponent} from 'react';

class StatisticShow extends PureComponent {

    state = {
        replace_data: {
            'TMO1': 'rutubet',
            'TMO2': 'hektolitre',
            'TMO4': 'kırık tane',
            'TMO6': 'cılız tane',
            'TMO8': 'haşere',
            'TMO11': 'süne',
            'TMO24': 'yabancı madde',
            'TMO31': 'protein',
            'TMO32': 'Fun FN',
            'TMO33': 'zeleny sedim',
            'TMO49': 'gecikmeli sed.',
            'TMO34': 'gluten',
            'TMO45': 'FN',
            'TMO46': 'İ. Öncesi',
            'TMO47': 'T.Y.Gluten',
            'TMO48': 'Gluten index',
            'TMO40': 'yağ',
        },
        block_key: [
            'TMO12', 'TMO13', 'TMO14', 'TMO15', 'TMO16', 'TMO17', 'TMO18', 'TMO19', 'TMO20', 'TMO21', 'TMO22',
            'TMO23', 'TMO25', 'TMO26', 'TMO27', 'TMO28', 'TMO29', 'TMO30', 'TMO35', 'TMO36', 'TMO37', 'TMO38',
            'TMO39', 'TMO41', 'TMO42', 'TMO43', 'TMO44', 'TMO3', 'TMO5', 'TMO7', 'TMO9', 'TMO10', 'il', 'ilce',
            'KoyKodu', 'TmoUrunKodu', 'URUN_ADI', 'OdemeDurum', 'UYEMI', 'ILILCE', 'SicilIl', 'SicilIlce',
            'DeneySorumlu', 'LabSorumlu'
        ]
    };

    replaceKey = (key) => {
        return this.state.replace_data[key] ? this.state.replace_data[key] : key
    };

    keyIsCheck = (key) => {
        return !this.state.block_key.includes(key);
    };

    render() {
        const {data} = this.props;
        let keys = [];
        if (data){
            keys = Object.keys(data);
        }

        return (
            <div>
                <hr className="no-print"/>
                {data ? (
                    <Fragment>
                        <button onClick={() => window.print()} className="no-print btn btn-info">Yazdır</button>
                        <table className="table">
                            <thead>
                            <tr>
                                <th scope="col">Key</th>
                                <th scope="col">Value</th>
                            </tr>
                            </thead>
                            <tbody>
                                {keys.map((item, key) => {
                                    return (
                                        this.keyIsCheck(item) &&
                                        <tr key={key}>
                                            <th scope="row">{this.replaceKey(item)}</th>
                                            <td>{data[item]}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>

                    </Fragment>
                ) : ('veri yok')}
            </div>
        );

    }
}

export default StatisticShow;
